import { ReactNode } from "react";
import { toast } from "react-toastify";
import type { TypeOptions } from "react-toastify";
import { twMerge } from "tailwind-merge";

type SignInToastProps = {
  title?: ReactNode;
  text?: ReactNode;
  type?: TypeOptions;
};

export function Toast({ title, text, type = "default" }: SignInToastProps) {
  toast(
    <div className="flex flex-col gap-[4px]">
      <p
        className={twMerge(
          "font-medium",
          type === "success" && "text-success-main",
          type === "error" && "text-danger-main",
          type === "info" && "text-info-main",
          type === "warning" && "text-warning-main",
        )}
      >
        {title}
      </p>
      {text}
    </div>,
    {
      position: "top-right",
      autoClose: 5000,
      closeOnClick: false,
      draggable: false,
      theme: "light",
      type,
    },
  );
}
